import * as React from "react";
import tw, { styled } from "twin.macro";

import SubHeader from "app/styles/SubHeader";
import { ReactComponent as ArrowIcon } from "app/assets/icons/chevron-right.svg";
import Text from "app/styles/Text";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  name: string;
  url: string;
  cryptoBalance?: string;
  fiatBalance?: string;
  noBorder?: boolean;
  code?: string;
}
export default function CryptoAssetButton(props: Props) {
  const { name, url, cryptoBalance, fiatBalance, code, ...rest } = props;

  return (
    <Container css={[!rest.noBorder && tw`border-b border-border`]} {...rest}>
      <img src={url} alt="Bitcoin" />

      <div tw="flex-grow flex justify-between items-center ml-[10px]">
        <div>
          <SubHeader tw="mobile:text-[1.4rem] whitespace-nowrap">
            {name}
          </SubHeader>
          <Text subdued small tw="mt-[4px] text-left">
            {code}
          </Text>
        </div>

        {!!(cryptoBalance && fiatBalance) && (
          <div tw="ml-[10px] text-right font-medium">
            <Text medium tw="mobile:text-base">
              {cryptoBalance}
            </Text>

            <Text small tw="text-grey mt-[2px]">
              {fiatBalance}
            </Text>
          </div>
        )}
      </div>

      <ArrowIcon color="#B2B2B2" />
    </Container>
  );
}

const Container = styled.button`
  ${tw`flex justify-between items-center py-[12px]`};

  > img {
    ${tw`w-[40px] h-[40px] flex-shrink-0 rounded-full mobile:w-[35px] mobile:h-[35px]`};
  }

  > svg {
    ${tw`w-[24px] h-[24px] flex-shrink-0 ml-[8px]`};
  }
`;
